export enum AttachmentsSourceGroupingOption {
  FORM_WORKFLOWS = 'FormWorkflows',
  MAPS_SETUP = 'MapsSetup',
}

export enum AttachmentGroupingOption {
  None = 'None',
  FileCategory = 'FileCategory',
  FileType = 'FileType',
  WorkflowCategory = 'WorkflowCategory',
  FormType = 'FormType',
  WorkflowStatus = 'WorkflowStatus',
  Location = 'Location',
  Company = 'Company',
  UploadedBy = 'UploadedBy',
  Date = 'Date',
}

export const attachmentsGroupingOptionList = Object.values(
  AttachmentGroupingOption,
)
